/* REACT PACKAGE IMPORTS */
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

/* INTERNAL IMPORTS */
import { LogOutAuthAction } from "../Features/Auth/Actions/AuthActions";
// Components
import NavBarEntra from "./NavBarEntra";
import IdleTimeOutModal from "./IdleTimeOutModal";

// Images
import logoLogout from "../assets/logout.svg";


const LayoutEntra = ({ tabs, logo, isEmbedded }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const appClass = isEmbedded ? "Embedded-App" : "App";

  const handleLogout = () => {
    dispatch(LogOutAuthAction())
      .then(() => {
        navigate("/login", { replace: true });
        if (document.fullscreenElement) document.exitFullscreen();
        window.location.reload(true);
        return false;
      });
  };

  return (
    <main className={appClass}>
      {/* shows inactivity */}
      <IdleTimeOutModal handleLogout={handleLogout} />
        <NavBarEntra
          tabs={tabs}
          logo={logo}
          logoLogout={logoLogout}
        />
      <Outlet />
    </main>
  );
};

export default LayoutEntra;